import React, { useContext } from 'react';
import { TranslationContext } from '../../../contexts/TranslationContext';
import { Chain, ChainClient } from '../../../services/WebApiClient';
import { useClient } from '../../../util/useClient';
import { FileUploader } from './FileUploader';

export function CssAdmin(props: {
    chain: Chain;
    onChange: () => void;
}) {

    const tc = useContext(TranslationContext);
    const chainClient = useClient(ChainClient);

    async function uploadCss(f: File) {
        console.log(`Uploading css ${f.name}`);
        try {
            await chainClient.setCss(props.chain.id, { fileName: "css.css", data: f });
        }
        catch (ex) {
            window.alert(`Could not upload .css: ${ex}`)
        }
        finally {
            props.onChange();
        }
    }

    return (
        <div className="css-admin">

            <FileUploader text={tc.translator("admin css upload text", "Drop .CSS file here to upload")}
                onSet={uploadCss}
            />

            {props.chain.cssUrl
                ? <a href={props.chain.cssUrl} download={`${props.chain.name}.css`}>{tc.translator("admin css download text", "Download .css file")}</a>
                : <span>{tc.translator("admin css no file", "No custom .css set")}</span>
            }
        </div>
	);
}
